module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M22.194 32H9.769c-1.147 0-1.778-.711-1.778-1.816V18.016H1.123c-1.145 0-1.466-.587-.723-1.426L14.635.619c.743-.839 1.95-.815 2.693.024l14.235 15.935c.743.839.421 1.438-.723 1.438h-6.868v12.17c0 1.103-.631 1.814-1.778 1.814z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/shift-1.js
// module id = 1410
// module chunks = 14